/**
 * WithdrawReasonField — the "Powód (opcjonalnie)" label + textarea pattern
 * shared by both staff withdraw-acceptance dialogs (single-version, on the
 * Versions tab, and bulk, on the offers list) so the field's markup,
 * `maxLength`, and testid convention stay in one place.
 */
import { Label } from '@ooh/ui/components/label';
import { Textarea } from '@ooh/ui/components/textarea';

export interface WithdrawReasonFieldProps {
  id: string;
  testId: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export function WithdrawReasonField({
  id,
  testId,
  label,
  value,
  onChange,
}: WithdrawReasonFieldProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Textarea
        id={id}
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={1000}
      />
    </div>
  );
}
